<div class="content" (resized)="onResizedContent($event)">
    <div *ngIf="!videoUrl" class="titulo">
        <img [src]='logo'>
    </div>
    <div *ngIf="videoUrl" class="card-inline" [style.width]="left + '%'" style="vertical-align: top; margin-right: 10px;">
        <div (resized)="onResizedLogo($event)" class="titulo">
            <img [src]='logo'>
        </div>
        <video [style.height]="getheightVideo() + 'px'" autoplay loop class="card-inline" controls="controls" #videoPlayer [src]="videoUrl">
            
        </video>
    </div>

    <div [style.width]="right + '%'" class="card-inline" style="vertical-align: top; text-align: center;">

        <mat-card *ngIf="getTopCaller" [style.background-color]="callerBackGroundColor" style="margin-bottom: 15px; text-align: center;">
            <div [style.background-color]="callerBackGroundColor" [style.color]="callerTextColor" class="numero"> {{ viewPatient ? getTopCaller.Patient : getTopCaller.CallerText }} </div>
            <div [style.background-color]="callerBackGroundColor" [style.color]="callerTextColor" class="ubicacion">{{ getTopCaller.Location }} </div>
        </mat-card>

        <mat-card [style.background-color]="backGroundColor" style="margin-bottom: 5px; text-align: center;" *ngFor="let caller of getCallers; let i = index;">
            <div [style.background-color]="backGroundColor" [style.color]="textColor" class="numero">{{ viewPatient ? caller.Patient : caller.CallerText }} </div>
            <div [style.background-color]="backGroundColor" [style.color]="textColor" class="ubicacion">{{ caller.Location }} </div>
        </mat-card>

    </div>
</div>